import { render, staticRenderFns } from "./ProductlabelsPage.vue?vue&type=template&id=e9ffa34a&scoped=true"
import script from "./ProductlabelsPage.vue?vue&type=script&lang=js"
export * from "./ProductlabelsPage.vue?vue&type=script&lang=js"
import style0 from "./ProductlabelsPage.vue?vue&type=style&index=0&id=e9ffa34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ffa34a",
  null
  
)

export default component.exports